import { render, staticRenderFns } from "./SetProperty.vue?vue&type=template&id=29264f2f"
import script from "./SetProperty.vue?vue&type=script&lang=js"
export * from "./SetProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports